// src/features/editor/components/studio/EditorLoadGate.tsx
import { Button, EmptyState } from '@teach/ui'
import { AlertTriangle } from 'lucide-react'
import { Spinner } from '@/components/common/Spinner'
import { useMessages } from '@/i18n'
import { messages } from './messages'

interface Props {
  /** Упала ПЕРВАЯ загрузка состояния модерации — показать курс нечем. */
  isError: boolean
  onRetry: () => void
}

/**
 * Экран до курса. Редактор ждёт первого ответа `/moderation`: без `draftId`
 * нельзя выбрать, что читать, а живая версия «пока не знаем» опасна —
 * `PUT` блока шлёт тело целиком и затёр бы черновик. Поэтому на ошибке —
 * не курс, а повтор (поллер и сам повторяет раз в `MODERATION_ERROR_RETRY_MS`).
 */
export const EditorLoadGate = ({ isError, onRetry }: Props) => {
  const m = useMessages(messages)
  return (
    <div className="flex h-dvh items-center justify-center bg-surface">
      {isError ? (
        <EmptyState
          icon={AlertTriangle}
          title={m.loadFailedTitle}
          description={m.loadFailedDescription}
          action={
            <Button variant="outline" onClick={onRetry}>
              {m.retry}
            </Button>
          }
        />
      ) : (
        <Spinner fullPage />
      )}
    </div>
  )
}
